
import BetOptions from "slotworks/components/betbar/vo/bet-options";
import Components from "slotworks/components/components";
import PaginationComponent from "slotworks/components/ui/pagination-component";
import Currency from "slotworks/i18n/currency";
import SlotDefinition from "slotworks/model/slot-definition";
import betModel from "slotworks/model/bets/bet-model";

export enum PayoutMode {
    LINES = "lines",
    WAYS = "ways"
}

export default class PaytableComponent extends PaginationComponent {

    public payoutMode: PayoutMode = PayoutMode.LINES;
    // The minimum bet in a ways game (if applicable)
    public waysBaseBet: number;

    private cachedBetOptions: BetOptions;

    public init(betOptions: BetOptions) {
        this.cachedBetOptions = betOptions;

        Components.betBar.onBetUpdated.add(this.populatePayouts);
        Components.betMenu.onBetOptionsCommitted.add(this.populatePayouts);
    }

    public refreshBetOptions() {
        const options = betModel.generateBetOptions();
        this.cachedBetOptions = options;
    }

    protected update() {
        super.update();

        this.populatePayouts();
    }

    private populatePayouts = (betOptions?: BetOptions) => {
        const symbols = SlotDefinition.symbolDefinitions;
        let lineBet: number;

        if (!betOptions) {
            betOptions = this.cachedBetOptions;
        } else {
            this.cachedBetOptions = betOptions;
        }

        if (betOptions) {
            if (this.payoutMode === PayoutMode.LINES) {
                lineBet = betOptions.stakePerLine * betOptions.coinSize;
            } else {
                lineBet = betOptions.getTotalStake() / this.waysBaseBet;
            }

            for (const symbol of symbols) {
                const payoutsText = this.contentLayer.getFlexiText("payouts_" + symbol.id);

                if (payoutsText) {
                    let payouts = "";
                    if (symbol.payouts) {
                        let output;
                        symbol.payouts.forEach((payout) => {
                            output = Currency.format(payout * lineBet, false);

                            if (payouts) {
                                payouts = output + "\n" + payouts;
                            } else {
                                payouts = output;
                            }
                        });
                    }

                    payoutsText.setText(payouts);
                }

                if (symbol.payouts) {
                    symbol.payouts.forEach((payout, matches) => {
                        const payoutText = this.contentLayer.getFlexiText("payouts_" + symbol.id + "_" + matches);

                        if (payoutText) {
                            payoutText.setText(Currency.format(payout * lineBet, false));
                        }
                    });
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/paytable/paytable-component.ts